import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { AlertController, Events } from 'ionic-angular';

@Injectable()
export class Utility {
    constructor(
        private alertCtl: AlertController,
        public events: Events,
    )
    {
        console.log('Just your friendly neighborhood Utility Man');

        this.events.subscribe('user:loggedIn', () => {
            this.cleanup()
        });
    }

    private materialsByCategory = false;
    private IDUser = Number(window.localStorage.getItem('IDUser'));
    private GUIDUser = window.localStorage.getItem('GUIDUser');
    private GUIDExternal = window.localStorage.getItem('GUIDExternal');
    private customProperties = window.localStorage.getItem('customProperties') ? JSON.parse(window.localStorage.getItem('customProperties')) : [];

    /**
     * @method category
     *
     * @param {boolean} byCategory - group materials by category, true/false
     */
    category (byCategory?: boolean) {
        if (byCategory === undefined) {
            return this.materialsByCategory;
        } else {
            this.materialsByCategory = byCategory;
            this.events.publish('material:categoryGrouping', this.materialsByCategory)
        }
    }

    cleanup () {
        window.localStorage.removeItem('customerSampleTypes');
        window.localStorage.removeItem('repUnits');
        window.localStorage.removeItem('CustomerTimezone');
        window.localStorage.removeItem('user');
        window.localStorage.removeItem('userData');
        this.IDUser = null;
        this.GUIDUser = null;
        this.GUIDExternal = null;
    }

    GenerationPattern() {
        let pattern = this.customProperties && this.customProperties.CustomSampleGUID ? this.customProperties.CustomSampleGUID : '';
        return pattern;
    }

    UserId (id?: number) {
        if (id) {
            this.IDUser = id;
            window.localStorage.setItem('IDUser', String(id))
        }
        return this.IDUser;
    }

    UserGuid (guid?: string) {
        if (guid) {
            this.GUIDUser = guid;
            window.localStorage.setItem('GUIDUser', guid)
        }
        return this.GUIDUser;
    }

    ExternalGuid (guid?: string) {
        if (guid) {
            this.GUIDExternal = guid;
            window.localStorage.setItem('GUIDExternal', guid)
        }
        return this.GUIDExternal;
    }

    CustomProperties (props?: any) {
        if(props) {
            this.customProperties = props;
            window.localStorage.setItem('customProperties', JSON.stringify(props))
        }
        return this.customProperties;
    }

    sampleTypes () {
        let type = this.customProperties && this.customProperties.SampleTypes ? this.customProperties.SampleTypes : [];
        return type;
    }

    repUnits () {
        let defaultUnit = [{ Hash: 'Variable Unit (english)', Name: 'Variable Unit (english)' }];
        return this.customProperties && this.customProperties.RepresentedQuantityUnits ? this.customProperties.RepresentedQuantityUnits : defaultUnit;
    }

    mapValueToKey (source, key, datafield) {
        return _.chain(source)
            .keyBy(key)
            .mapValues(datafield)
            .value();
    }

    async popUpAlert (title, message) {
        return new Promise(async (resolve) => {
            const inform = this.alertCtl.create({
                title: title,
                message: `${message}. Do you wish to continue?`,
                cssClass: 'materialsAlert',
                buttons: [
                    {
                        text: 'Yes',
                        handler: () => {
                            resolve(true);
                        }
                    },
                    {
                        text: 'No',
                        handler: () => {
                            resolve(false);
                        }
                    }
                ]
            })
            inform.present();
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/util-service/util-service.ts